/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserRole } from './userRole';
import type { UserLifecycleState } from './userLifecycleState';
import type { UserShortCohortId } from './userShortCohortId';
import type { UserShortCohortTitle } from './userShortCohortTitle';

/**
 * Lightweight user record for rosters and lists
 */
export interface UserShort {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  role: UserRole;
  /** Lifecycle state for all users. Note that 'stale' and 'finished' primarily apply to students. */
  state?: UserLifecycleState;
  cohortId?: UserShortCohortId;
  cohortTitle?: UserShortCohortTitle;
}
